export enum DeviceType {
    GPU = "GPU",
    ROUTER = "router",
    CAMERA = "camera",
}
